export const Glitch=()=>{

    return(
        <div 
        className="boxer"
        >
        <div className="glitchContainer">
        <div className="glitch" data-text="Cosmos Currency"></div>
        <div className="glow"></div>
        <p className="subtitle">blessed</p>
        </div>
        <div className="scanlines"></div>
        </div>
    )
}